'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pullout = require('../../../pullout');

var _pullout2 = _interopRequireDefault(_pullout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'render',
    value: function render() {
      var filteredProps = {
        content: {
          headline: this.props.content.headline,
          ios: this.props.content.ios,
          android: this.props.content.android
        },
        config: {
          appBadge: true,
          textAlign: this.props.config.textAlign || 'left',
          theme: this.props.config.theme,
          id: this.props.config.id || null,
          backgroundImage: this.props.config.backgroundImage,
          backgroundPosition: this.props.config.backgroundPosition
        },
        clientInfo: this.props.clientInfo
      };
      if (this.props.content.paragraph && this.props.content.paragraph.text) {
        filteredProps.content.paragraph = this.props.content.paragraph;
      }
      if (this.props.content.hatchText && this.props.content.hatchText.text) {
        filteredProps.content.hatchText = this.props.content.hatchText;
      }
      if (this.props.className) {
        filteredProps.className = this.props.className;
      }

      return _react2.default.createElement(_pullout2.default, filteredProps);
    }
  }]);

  return App;
}(_react2.default.Component);

exports.default = App;


App.propTypes = {
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired
    })
  }),
  config: _propTypes2.default.shape({
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light', 'theme-background-image-dark', 'theme-background-image-light']).isRequired,
    id: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    textAlign: _propTypes2.default.oneOf(['left', 'right', 'center'])
  }),
  className: _propTypes2.default.string,
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string.isRequired,
    client_is_mobile: _propTypes2.default.bool.isRequired
  }).isRequired
};

App.defaultProps = {
  config: {
    theme: 'theme-background-image-dark',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-prospects.jpg',
      portable: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-prospects.jpg',
      mobile: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-prospects.jpg'
    },
    backgroundPosition: 'center',
    textAlign: 'left',
    id: ''
  },
  content: {
    headline: {
      text: 'Fewer than 24 characters.'
    },
    paragraph: {
      text: 'Fewer than 120 characters for paragraph text to ' + 'equal approximately 3 lines of text or less, in mobile and tablet views.'
    },
    hatchText: {
      text: '90 characters or less of text or no more than 2 ' + 'lines of text in mobile portrait view.'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy'
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/pullout/app/jsx/App.js
// module id = 1134
// module chunks = 4